import { encore, resto, userService } from '@saucelabs/sl-util-axios';
import { PAGINATION_LIMIT } from '@saucelabs/sl-util-config';

export const getSamlSettings = ({ username }) => (
  resto.get(`/rest/v1/${username}/saml`)
);

export const postSamlSettings = ({ username, payload }) => (
  encore.post(`/api/user/${username}/saml`, payload)
);

export const updateSetting = (payload) => (
  encore.post('/api/update', payload)
);

export const deleteSamlFile = ({ username }) => (
  encore.post(`/api/user/${username}/saml/delete`)
);

export const resetAccessKeys = () => (
  resto.post('/rest/v1/users/accesskey/change-all')
);

export const getOrganization = ({ organizationId }) => (
  userService.get(`/v1/organizations/${organizationId}/`)
);

export const patchUSSettings = ({ organizationId, ...payload }) => (
  userService.patch(`/v1/organizations/${organizationId}/settings/`, payload)
);

export const getUsersToTransfer = ({
  organizationId,
  limit = PAGINATION_LIMIT,
  offset = 0,
  ...rest
}) => (
  userService.get(`/v1/organizations/${organizationId}/transferable-users/`, {
    params: {
      limit,
      offset,
      ...rest,
    },
  })
);
